import EurekaUiFramwork from './eureka'
EurekaUiFramwork.version = '0.0.12'
export default EurekaUiFramwork;
